
export const copy = {
    ru: {
        pageTitle: 'Список изменений',
        eyebrow: 'Обновление баланса', general: 'Общие изменения', global: 'Глобальные изменения',
        items: 'Изменения предметов', heroes: 'Изменения героев', abilities: 'Способности',
        talents: 'Таланты', base: 'Основные параметры',
        str: 'Сила', agi: 'Ловкость', int: 'Интеллект',
        bosses: 'Изменения боссов', neutralCreeps: 'Нейтральные крипы',
        baseItems: 'Основные предметы', upgradeItems: 'Улучшения',
        neutralItems: 'Нейтральные предметы', neutralArtifacts: 'Изменения артефактов', neutralEnhancements: 'Изменения чар',
        newBadge: 'Новый', newHeroBadge: 'Новый герой', newBossBadge: 'Новый босс',
        empty: 'Для этого патча изменений нет',
    },
    en: {
        pageTitle: 'Changelog',
        eyebrow: 'Balance update', general: 'General changes', global: 'Global changes',
        items: 'Item changes', heroes: 'Hero changes', abilities: 'Abilities',
        talents: 'Talents', base: 'Base attributes',
        str: 'Strength', agi: 'Agility', int: 'Intelligence',
        bosses: 'Boss changes', neutralCreeps: 'Neutral creeps',
        baseItems: 'Basic items', upgradeItems: 'Upgrades',
        neutralItems: 'Neutral items', neutralArtifacts: 'Artifact changes', neutralEnhancements: 'Enhancement changes',
        newBadge: 'New', newHeroBadge: 'New hero', newBossBadge: 'New boss',
        empty: 'No changes for this patch',
    },
    uk: {
        pageTitle: 'Список змін',
        eyebrow: 'Оновлення балансу', general: 'Загальні зміни', global: 'Глобальні зміни',
        items: 'Зміни предметів', heroes: 'Зміни героїв', abilities: 'Здібності',
        talents: 'Таланти', base: 'Основні параметри',
        str: 'Сила', agi: 'Спритність', int: 'Інтелект',
        bosses: 'Зміни босів', neutralCreeps: 'Нейтральні кріпи',
        baseItems: 'Основні предмети', upgradeItems: 'Покращення',
        neutralItems: 'Нейтральні предмети', neutralArtifacts: 'Зміни артефактів', neutralEnhancements: 'Зміни чар',
        newBadge: 'Новий', newHeroBadge: 'Новий герой', newBossBadge: 'Новий бос',
        empty: 'Для цього патчу змін немає',
    },
    cs: {
        pageTitle: 'Seznam změn',
        eyebrow: 'Aktualizace vyvážení', general: 'Obecné změny', global: 'Globální změny',
        items: 'Změny předmětů', heroes: 'Změny hrdinů', abilities: 'Schopnosti',
        talents: 'Talenty', base: 'Základní atributy',
        str: 'Síla', agi: 'Obratnost', int: 'Inteligence',
        bosses: 'Změny bossů', neutralCreeps: 'Neutrální jednotky',
        baseItems: 'Základní předměty', upgradeItems: 'Vylepšení předmětů',
        neutralItems: 'Neutrální předměty', neutralArtifacts: 'Změny artefaktů', neutralEnhancements: 'Změny vylepšení',
        newBadge: 'Nový', newHeroBadge: 'Nový hrdina', newBossBadge: 'Nový boss',
        empty: 'Pro tento patch nejsou žádné změny',
    },
};

export type Copy = (typeof copy)['ru'];
